import React from 'react';
import { Link } from 'react-router-dom';
import { isMobile, getPlatform } from '../utils/pwa';

const InstallPage = () => {
  const mobile = isMobile();
  const platform = getPlatform();

  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="text-center mb-8">
        <div className="text-6xl mb-4">🌱</div>
        <h1 className="text-3xl font-bold text-gray-800">Install Our Pickup</h1>
        <p className="text-gray-600 mt-2">Get the best experience on your device</p>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
        {mobile ? (
          <>
            {platform === 'ios' && (
              <div className="space-y-4">
                <h3 className="text-lg font-semibold">📱 iOS Installation</h3>
                <ol className="list-decimal list-inside space-y-3 text-gray-700">
                  <li>Tap the <strong>Share</strong> button <span className="text-xl">⎙</span> at the bottom of the screen</li>
                  <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
                  <li>Tap <strong>"Add"</strong> in the top-right corner</li>
                </ol>
                <div className="bg-blue-50 p-4 rounded-lg text-sm text-blue-700">
                  💡 The Our Pickup icon will appear on your home screen like a regular app!
                </div>
              </div>
            )}

            {platform === 'android' && (
              <div className="space-y-4">
                <h3 className="text-lg font-semibold">🤖 Android Installation</h3>
                <ol className="list-decimal list-inside space-y-3 text-gray-700">
                  <li>Tap the <strong>menu</strong> button <span className="text-xl">⋮</span> in the top-right corner</li>
                  <li>Tap <strong>"Install App"</strong> or <strong>"Add to Home Screen"</strong></li>
                  <li>Tap <strong>"Install"</strong> to confirm</li>
                </ol>
                <div className="bg-green-50 p-4 rounded-lg text-sm text-green-700">
                  💡 The Our Pickup app will appear in your app drawer and home screen!
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-600">Please visit this page on your mobile device to install Our Pickup.</p>
            <p className="text-sm text-gray-400 mt-2">Or scan the QR code to open on your phone.</p>
          </div>
        )}
      </div>

      <div className="bg-gray-50 rounded-lg p-6 text-center">
        <h3 className="font-semibold text-gray-700 mb-2">Already have the app?</h3>
        <Link to="/" className="text-green-600 hover:underline">
          Go to Our Pickup →
        </Link>
      </div>
    </div>
  );
};

export default InstallPage;
